import { render } from "./BuyerList.vue?vue&type=template&id=69d001f9&scoped=true"
import script from "./BuyerList.vue?vue&type=script&lang=js"
export * from "./BuyerList.vue?vue&type=script&lang=js"

import "./BuyerList.vue?vue&type=style&index=0&id=69d001f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d001f9"]])

export default __exports__